import { Stack } from "@mui/material";
import { FC, useEffect } from "react";
import { ExplainWithAiMetaData } from "@/components/common/explain-with-ai-drawer/components/common/ExplainWithAiMetaData";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { explainWithAIFormattedCurrentBillingDataSelector } from "@/store/explain-with-ai/selectors/explainWithAIFormattedCurrentBillingDataSelector";
import { explainWithAiNewDataNeededSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiNewDataNeededSelector";
import { ExplainWithAiBodyContent } from "@/components/common/explain-with-ai-drawer/components/body/components/ExplainWithAiBodyContent";
import { initiateExplainWithAiThunk } from "@/store/explain-with-ai/thunks/initiateExplainWithAiThunk";
import { updateExplainWithAiDataThunk } from "@/store/explain-with-ai/thunks/updateExplainWithAiDataThunk";
import { explainWithAIModeSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAIModeSelector";
import { ExplainWithAiPanelHeader } from "@/components/common/explain-with-ai-drawer/components/ExplainWithAiPanelHeader";
import { explainWithAiWidgetIdSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiWidgetIdSelector";
import { explainWithAiWidgetNameSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiWidgetNameSelector";
import { languageSelector } from "@/store/language-select/selectors/languageSelector";

interface ExplainWithAiPanelBodyProps {
  onClose(): void;
}
export const ExplainWithAiPanelBody: FC<ExplainWithAiPanelBodyProps> = ({
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const language = useAppSelector(languageSelector);

  const currentBillingData = useAppSelector(
    explainWithAIFormattedCurrentBillingDataSelector,
  );
  const widgetId = useAppSelector(explainWithAiWidgetIdSelector);
  const widgetName = useAppSelector(explainWithAiWidgetNameSelector);
  const newDataNeeded = useAppSelector(explainWithAiNewDataNeededSelector);
  const mode = useAppSelector(explainWithAIModeSelector);

  useEffect(() => {
    if (mode && widgetId) {
      dispatch(initiateExplainWithAiThunk());
    }
  }, [dispatch, mode, widgetId, language]);

  useEffect(() => {
    dispatch(updateExplainWithAiDataThunk());
  }, [dispatch, newDataNeeded]);

  return (
    <Stack spacing={1.5} px={1}>
      <ExplainWithAiPanelHeader onClose={onClose} />
      {newDataNeeded && currentBillingData && (
        <Stack bgcolor="grey.200" borderRadius={2} p={1.5}>
          <ExplainWithAiMetaData
            grouping={currentBillingData.grouping}
            trendType={currentBillingData.trendType}
            dates={currentBillingData.dates}
            widgetName={widgetName}
            showExplainButton
            index={0}
          />
        </Stack>
      )}

      <ExplainWithAiBodyContent />
    </Stack>
  );
};
